/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
type ProjectId = string;

/**
 * Generates the full URL for fetching issue types for projects
 * @param projectIds - Array of project IDs to include in query parameters
 * @returns Complete URL with query parameters and optional operation tracing
 */
export const getIssueTypesForProjectsUrl = (projectIds: ProjectId[]): string => {
	const queryParams = new URLSearchParams();

	projectIds.forEach((projectId) => {
		queryParams.append('projectId', projectId);
	});

	const operationParam = '&operation=GetIssueTypesForProjects';

	return `/rest/polaris/v2/project/settings/issuetype?${queryParams.toString()}${operationParam}`;
};
